export default __webpack_public_path__ + "static/media/ocean-export-light.0fcd3306.svg";